// Hide free shipping popup after 5 seconds
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Hide Klaviyo popups
    const klaviyoPopups = document.querySelectorAll('[class*="kl-teaser"], [class*="kl-private"], .klaviyo-form-modal, .klaviyo-popup');
    klaviyoPopups.forEach(function(popup) {
      if (popup) {
        popup.style.display = 'none';
        popup.style.visibility = 'hidden';
      }
    });
    
    // Hide any popup with "free shipping" text
    const allPopups = document.querySelectorAll('div[style*="position: fixed"], div[style*="position: absolute"]');
    allPopups.forEach(function(popup) {
       if (popup.textContent && popup.textContent.toLowerCase().includes('free shipping')) {
        popup.style.display = 'block';
        popup.style.visibility = 'visible';
      }
     });
  }, 5000); // 5 seconds delay
});



